import * as yup from "yup";

export const agencySchema = yup.object().shape({
    name: yup.string().required("Le nom de l'entreprise est obligatoire"),
    phone: yup.string().required("Le numéro de téléphone de l'entreprise est obligatoire"),
    code: yup.string().required("Le code client de l'entreprise est obligatoire"),
    address: yup.string().required("L'adresse de l'entreprise est obligatoire"),
    agencyUid: yup.string()
})
